<div class="container-fluid">
  <!-- Page Header with Utility Buttons -->
  <div class="d-flex flex-column flex-lg-row justify-content-lg-between align-items-start align-items-lg-baseline mb-3">
    <h1 class="page-header mb-2 mb-lg-0">Payments Past Due Report</h1>

    <!-- Utility Buttons -->
    <div class="d-flex align-items-center" style="margin-top: 0.5rem;">
      <button style="background-color: transparent !important; border: none;"
        (click)="onPrint()"
        type="button"
        mat-icon-button
        class="mb-1"
        matTooltip="Print payments past due report"
        matTooltipPosition="below"
        aria-label="Print payments past due report">
        <mat-icon style="color: #1C3F8B;">print</mat-icon>
      </button>
    </div>
  </div>

  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        Filter
      </mat-panel-title>
      <mat-panel-description>
        <app-filter-results-panel [parameters]=queryParams></app-filter-results-panel>
      </mat-panel-description>
    </mat-expansion-panel-header>
    <form (ngSubmit)="onSubmit(f)" #f=ngForm class="form">
      <div class="row">

        <div class="col-12 col-sm-6 col-lg">
          <mat-form-field class="full-width-field">
              <mat-label>Enter a date range</mat-label>
              <input matInput
                  [owlDateTime]="picker_daterange_start_end"
                  [owlDateTimeTrigger]="picker_daterange_start_end"
                  [selectMode]="'range'"
                  [(ngModel)]="dateRange"
                  [max]="today"
                  placeholder="Select date range"
                  readonly
                  name="field_payment_date_value"
                  (dateTimeChange)="dateRangeChange($event)">
              <span class="cursor-pointer" matSuffix [owlDateTimeTrigger]="picker_daterange_start_end">
                  <mat-icon>calendar_today</mat-icon>
              </span>
              <owl-date-time #picker_daterange_start_end [pickerType]="'calendar'"></owl-date-time>
          </mat-form-field>
      </div>

        <!-- Enrollment Autocomplete -->
        <!-- <div class="col-3">
          <mat-form-field class="full-width-field">
            <mat-label>Enrollment</mat-label>
            <input name="field_lesson_type" (input)="onEnrollmentAutocomplete($event)" matInput ngModel
              [matAutocomplete]="autoCompleteEnrollment">
            <button type="button" matSuffix mat-icon-button aria-label="manage_accounts">
              <mat-icon>manage_accounts</mat-icon>
            </button>
          </mat-form-field>
          <mat-autocomplete #autoCompleteEnrollment="matAutocomplete" (optionSelected)="onSubmit(f)">
            <mat-option *ngFor="let option of autoCompleteEnrollmentOptions" [value]="option.label + ' ' + '(' + option.value + ')'">
              {{option.label}} ({{option.value}})
            </mat-option>
          </mat-autocomplete>
        </div> -->

        <section class="section">
          <div class="float-end bring-inline">
            <button (click)="resetForm()" color="primary" mat-flat-button class="me-1" mat-button>Clear
              <!-- <mat-icon (click)="resetForm()" aria-hidden="false" aria-label="Menu dropdown" class=""></mat-icon> -->
            </button>
          </div>

        </section>

      </div>

      <section class="section">
      </section>

    </form>

  </mat-expansion-panel>

  <mat-progress-bar [class.invisible]="!ShowProgressBar" mode="indeterminate"></mat-progress-bar>

  <div class="table-responsive-sticky table-responsive">

    <table mat-table #displayTable [dataSource]="dataSource" matSort (matSortChange)="sortDataView($event)" class="mt-4">


      <!-- Oldest overdue installment date -->
      <ng-container matColumnDef="oldest_due_date">
        <th mat-header-cell mat-sort-header *matHeaderCellDef sortActionDescription="Sort by Oldest Due Date">
          Oldest Due Date
        </th>
        <td mat-cell *matCellDef="let element">
          {{ reportDateService.formatDate(element.oldest_due_date) }}
          <div class="small text-muted">{{ reportDateService.relativeDueLabel(element.oldest_due_date) }}</div>
        </td>
      </ng-container>

      <!-- Student -->
      <ng-container matColumnDef="student_name">
        <th mat-sort-header mat-header-cell *matHeaderCellDef sortActionDescription="Sort by Student">
          Student
        </th>
        <td mat-cell *matCellDef="let element"> {{ element.student_name }} </td>
      </ng-container>

      <!-- Enrollment -->
      <ng-container matColumnDef="enrollment_title">
        <th mat-sort-header mat-header-cell *matHeaderCellDef sortActionDescription="Sort by Enrollment">
          Enrollment
        </th>
        <td mat-cell *matCellDef="let element"> {{ element.enrollment_title }} </td>
      </ng-container>

      <!-- Amount Due: amount currently overdue, capped at the remaining balance -->
      <ng-container matColumnDef="amount_due">
        <th mat-sort-header mat-header-cell *matHeaderCellDef sortActionDescription="Sort by Amount Due" class="text-end">
          Amount Due
        </th>
        <td mat-cell *matCellDef="let element" class="text-end"> {{ element.amount_due | studioCurrency }} </td>
      </ng-container>

      <!-- Total Balance: enrollment's remaining balance -->
      <ng-container matColumnDef="total_balance">
        <th mat-sort-header mat-header-cell *matHeaderCellDef sortActionDescription="Sort by Total Balance" class="text-end">
          Total Balance
        </th>
        <td mat-cell *matCellDef="let element" class="text-end"> {{ element.total_balance | studioCurrency }} </td>
      </ng-container>

      <!-- Number of overdue installments -->
      <ng-container matColumnDef="overdue_count">
        <th mat-sort-header mat-header-cell *matHeaderCellDef sortActionDescription="Sort by Overdue Payments">
          Overdue Payments
        </th>
        <td mat-cell *matCellDef="let element"> {{ element.overdue_count }} </td>
      </ng-container>

      <!-- Lessons remaining -->
      <ng-container matColumnDef="lessons_remaining">
        <th mat-sort-header mat-header-cell *matHeaderCellDef sortActionDescription="Sort by Lessons Remaining">
          Lessons Remaining
        </th>
        <td mat-cell *matCellDef="let element"> {{ +element.lessons_remaining }} </td>
      </ng-container>

      <!-- Teacher -->
      <ng-container matColumnDef="instructor">
        <th mat-sort-header mat-header-cell *matHeaderCellDef sortActionDescription="Sort by Teacher">
          Teacher
        </th>
        <td mat-cell *matCellDef="let element"> {{ element.instructor }} </td>
      </ng-container>

      <!-- REPLACE Column -->
      <!-- <ng-container matColumnDef="REPLACE">
        <th mat-header-cell *matHeaderCellDef sortActionDescription="Sort by REPLACE">
          REPLACE
        </th>
        <td mat-cell *matCellDef="let element"> {{ element.REPLACE }} </td>
      </ng-container> -->

      <!-- Footer for pagination -->
      <ng-container matColumnDef="pagination-footer">
        <td mat-footer-cell *matFooterCellDef [attr.colspan]="displayedColumns.length">
          <mat-paginator (page)="pageChanged($event)" [pageSizeOptions]="onPageSizeOptions()" [length]="30"
            [disabled]="ShowProgressBar"
            [pageSize]="paginationTotalPages" [pageIndex]="paginationIndex" aria-label="Select page of view"></mat-paginator>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row matRipple *matRowDef="let row; columns: displayedColumns;"></tr>
      <tr mat-footer-row *matFooterRowDef="['pagination-footer']; sticky: true"></tr>
    </table>

  </div>
</div>
